






































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import Icon from '@/components/Icon/Icon.vue'
import Collapse from '@/components/Collapse/Collapse.vue'
import ToggleArrow from '@/components/ToggleArrow/ToggleArrow.vue'
import InlineTextEditor, {
  OnSendData,
} from '@/components/InlineTextEditor/InlineTextEditor.vue'
import KnowledgeBlockComponent from './KnowledgeBlock.vue'
import { KnowledgeAction } from '@/store/modules/knowledge/actions'
import {
  KnowledgeBlock,
  KnowledgeSection,
  UpdateKnowledgeSectionRequest,
} from '@/models/knowledge'

interface Data {
  isBlocksInProgress: boolean
}

interface Methods {
  getBlocks: () => Promise<void>
  handleCreateBlock: () => void
  handleUpdateSection: (data: OnSendData) => Promise<void>
  handleDeleteSection: () => void
  handleToggleCollapse: () => Promise<void>
}

interface Computed {
  blocks?: KnowledgeBlock[]
  selectedBaseId?: string
  isCollapsed: boolean
  openSectionIds: string[]
}

interface Props {
  section: KnowledgeSection
  isReadonly?: boolean
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Icon,
    Collapse,
    ToggleArrow,
    InlineTextEditor,
    KnowledgeBlockComponent,
  },
  props: {
    section: {
      required: true,
    },
    isReadonly: {
      default: () => false,
    },
  },
  data() {
    return {
      isBlocksInProgress: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedBaseId: 'getSelectedKnowledgeBaseId',
      openSectionIds: 'getOpenSectionIds',
    }),
    blocks() {
      return this.$store.getters.getKnowledgeBlocksBySectionId(this.section.id)
    },
    isCollapsed() {
      return !this.openSectionIds.includes(this.section.id)
    },
  },
  methods: {
    async getBlocks() {
      if (this.selectedBaseId && !this.isBlocksInProgress) {
        this.isBlocksInProgress = true
        await this.$store.dispatch(KnowledgeAction.GetBlocks, {
          baseId: this.selectedBaseId,
          sectionId: this.section.id,
        })
        this.isBlocksInProgress = false
      }
    },
    handleCreateBlock() {
      if (this.selectedBaseId) {
        this.$store.dispatch(KnowledgeAction.CreateBlock, {
          baseId: this.selectedBaseId,
          sectionId: this.section.id,
        })
      }
    },
    async handleUpdateSection({ value, resolve, reject }) {
      if (!this.selectedBaseId) {
        return
      }

      try {
        const payload: UpdateKnowledgeSectionRequest = {
          baseId: this.selectedBaseId,
          sectionId: this.section.id,
          title: value,
        }
        await this.$store.dispatch(KnowledgeAction.UpdateSection, payload)
        resolve()
      } catch (e) {
        reject()
      }
    },
    handleDeleteSection() {
      this.$useConfirmDialog(
        [
          this.$tc('knowledge.sectionRemoveConfirm'),
          {
            type: 'danger',
            okText: this.$tc('common.remove'),
            cancelText: this.$tc('common.cancel'),
          },
        ],
        async () => {
          await this.$store.dispatch(KnowledgeAction.DeleteSection, {
            baseId: this.selectedBaseId,
            sectionId: this.section.id,
          })
          this.$store.dispatch(ADD_TOAST_MESSAGE, {
            text: this.$tc('knowledge.actions.removeSuccess'),
            type: 'success',
          })
        },
        !!this.selectedBaseId,
      )
    },
    async handleToggleCollapse() {
      if (!this.blocks) {
        await this.getBlocks()
      }
      this.$store.dispatch(KnowledgeAction.ToggleSection, this.section.id)
    },
  },
})
